import { uniqueId } from 'lodash';
import { createApp } from 'vue';
import { isFalse, isTrue } from '@/libs/boolean';
import ModalRemoto from '@/components/ModalRemoto.vue';
import ApplicationController from './application_controller';

export const EVENTO_CARGADO = 'modal-remoto:cargado';
export const EVENTO_ANTES_CARGAR = 'modal-remoto:antes-cargar';
const MODAL_HOLDER_ID = 'remote-modal-holder';
const EVENT_CLICK = 'click';

const DEFAULT_CONFIG = {
  modalId: '',
  title: '',
  modalTitulo: '',
  url: '',
  modalClasses: '',
  loadComponents: true,
  mostrarBotonCerrar: true,
  modalConfig: null,
};

// Creamos el holder para los modales
Cifra.Modals.addHolder(MODAL_HOLDER_ID);

/**
 * Este componenete lo que hace es llamar a la URL que tenga el elemento
 * y el html que devuelve lo muestra en un modal. Utiliza modal de bootstrap
 * por lo que seguimos dependiendo tanto de jquery como de Cifra
 */
/* global Cifra, $, I18n */
export default class extends ApplicationController {
  connect() {
    this._config = {
      ...DEFAULT_CONFIG,
      ...this.element.dataset,
    };

    if (!this._config.modalId) {
      this._config.modalId = uniqueId('remote-modal');
    }
    this.$element = $(this.element);
    this._addEventListeners();
    this._conectarTooltipTitle();
  }

  show() {
    if (this.modalRemoto) {
      this.modalRemoto.unmount();
    }

    this.modalRemoto = this.#createModalApp();
    const modalRemotoVm = this.modalRemoto.mount(Cifra.Modals.getHolder(MODAL_HOLDER_ID)[0]);

    modalRemotoVm.show();
  }

  hide() {
    if (this.$modal) {
      this.$modal.modal('hide');
    }
  }

  setTitle(title) {
    this._config.title = title;
  }

  setModalId(modalId) {
    this._config.modalId = modalId;
  }

  _addEventListeners() {
    this.$element.on(EVENT_CLICK, (event) => {
      event.preventDefault();
      // Dejamos que siga procesando otros eventos porque si no no nos podemos
      // conectar desde otro js (por ejemplo para cerrar el dropdown de classroom del cuaderno).
      this.show();
    });
  }

  _conectarTooltipTitle() {
    // Si tiene title activamos el tooltip de bootstrap
    const title = this.$element.attr('title');
    if (title) {
      this.$element.tooltip();
    }
  }

  #createModalApp() {
    const controller = this;
    const config = this._config;
    const url = config.url || this.element.getAttribute('href') || '';

    const app = createApp(
      ModalRemoto,
      {
        id: config.modalId,
        titulo: config.modalTitulo,
        url,
        classModal: config.modalClasses,
        mostrarBotonCerrar: !isFalse(config.mostrarBotonCerrar),
        tamano: config.modalTamano,
        alturaCompleta: isTrue(config.modalAlturaCompleta),
        modalConfig: config.modalConfig ? JSON.parse(config.modalConfig) : null,
        onHtmlActualizado() {
          controller.#lanzarEventoLoaded();
        },
        onPrepararPeticion(evento) {
          controller.#lanzarEventoAntesCargar(evento);
        },
      },
    );
    app.provide('I18n', I18n);
    return app;
  }

  #lanzarEventoLoaded() {
    // Lanzamos evento especial también en el document a parte del propio elemento
    const evento = new CustomEvent(EVENTO_CARGADO, {
      detail: {
        controller: this,
        modal: this.$modal,
      },
    });
    document.dispatchEvent(evento);
  }

  #lanzarEventoAntesCargar(eventoVue) {
    const { url } = eventoVue;
    // Lanzamos evento especial también en el document a parte del propio elemento
    const evento = new CustomEvent(EVENTO_ANTES_CARGAR, {
      cancelable: true,
      detail: {
        controller: this,
        url: new URL(url, window.location.origin),
      },
    });
    this.element.dispatchEvent(evento);

    // Si hacen el preventDefault() entonces cancelan la petición
    if (evento.defaultPrevented) {
      eventoVue.cancelar = true;
    }
    if (eventoVue.cancelar) {
      this.cancelado = true;
    }
    eventoVue.url = evento.detail.url.toString();
  }
}
